import type { SVGProps } from 'react';

export const BookmarkRemove = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M20.5 7H15V5.5h5.5V7Zm-15 13.25V5.308c0-.505.175-.933.525-1.283.35-.35.778-.525 1.283-.525h6.576a5.906 5.906 0 0 0-.663 1.317A4.39 4.39 0 0 0 13 6.25c0 1.18.382 2.212 1.147 3.093.765.882 1.716 1.41 2.853 1.586.287.037.537.056.75.056.213 0 .463-.02.75-.056v9.321L12 17.462 5.5 20.25Z" />
    </svg>
  );
};
